export default {
    copy_link: 'Copy URL',
    committee_name: 'Affiliated Merchant',
    meeting_url: 'Meeting URL',
    meeting_cn_name: 'Chinese Name',
    meeting_en_name: 'English Name',
    meeting_desc: 'Meeting Introduction',
    meeting_start_date: 'Meeting Start Time',
    meeting_end_date: 'Meeting End Time',
    meeting_report_date: 'On - site Check - in Time',
    city_name: 'City and Province',
    meeting_address_cn: 'Venue Chinese Name',
    meeting_address_en: 'Venue English Name',
    meeting_credit_type: 'Credit Type',
    meeting_type: 'Meeting Type',
    meeting_subject_class: 'Subject Category',
    meeting_link_person: 'Contact Person',
    meeting_link_mobile: 'Mobile Phone Number',
    show_meeting_list: 'Display in Merchant Meeting List',
    meeting_meta_keywords: 'Search Engine Keywords',
    meeting_meta_description: 'Search Engine Description',
    meeting_tongji_code: 'Statistics Code',
    phoneFormatReg: 'Incorrect mobile phone number format',

    meeting_default_home: 'Website Default Homepage',
    meeting_personal_lang: 'Personal Center Language',
    meeting_jump_type: 'Representatives from Hong Kong, Macao and Taiwan',
    meeting_welcome_pc: 'Welcome Page Content (PC)',
    meeting_welcome_h5: 'Welcome Page Content (H5)',
    meeting_welcome_link: 'Welcome Page Production Method',
    meeting_welcome_pc_tips: 'PC welcome page size: 1920*1080 「Effective area 1140*600」, the effective area is centered and above',
    meeting_welcome_h5_tips: 'H5 welcome page size: 1080*1700 「Effective area 700*1420」, the effective area is centered and above',

    meeting_image_980x200: 'Meeting Image (980*200px)',
    meeting_image_980x200_tips:
        'Used for pages with this image ratio such as personal registration and login, team registration and login, and exhibitor registration and login on the meeting front - end',
    meeting_image_900x500: 'Meeting Image (900*500px)',
    meeting_image_900x500_tips: 'Used for meeting display pages with this image ratio',
    meeting_image_300x300: 'Meeting Image (300*300px)',
    meeting_image_300x300_tips: 'Used for meeting link sharing images and other pages with this image ratio',
    meeting_image_affix: 'Recommended size <span class="error - color fs16 bold">{size}</span>px, supports JPG, GIF, PNG image files, and the file size cannot exceed 2M',
    go_to_make: 'Go to Make',

    // Dynamic Table Component
    add_row: 'Add Row',
    target: 'Target',
    link: 'Link',
    title: 'Title',
    jump_method: 'Jump Method',
    operation: 'Operation',
    delete: 'Delete',

    // Welcome Edit Component
    edit_pc_welcome: 'Edit PC Welcome Page',
    edit_h5_welcome: 'Edit H5 Welcome Page',
    upload_image: 'Upload Image',
    generate_code: 'Generate Code',
    only_image_allowed: 'Only image files can be uploaded'
};
